
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"opacity":"0.3"}},[_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M1.25 1.78136C1.25 1.48898 1.48703 1.25195 1.77941 1.25195H6.72059C7.01297 1.25195 7.25 1.48898 7.25 1.78136V6.72254C7.25 7.01493 7.01297 7.25195 6.72059 7.25195H1.77941C1.48703 7.25195 1.25 7.01493 1.25 6.72254V1.78136ZM2.30882 2.31078V6.19313H6.19118V2.31078H2.30882Z","fill":"#0D1728"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M8.75 1.78136C8.75 1.48898 8.98703 1.25195 9.27941 1.25195H14.2206C14.513 1.25195 14.75 1.48898 14.75 1.78136V6.72254C14.75 7.01493 14.513 7.25195 14.2206 7.25195H9.27941C8.98703 7.25195 8.75 7.01493 8.75 6.72254V1.78136ZM9.80882 2.31078V6.19313H13.6912V2.31078H9.80882Z","fill":"#0D1728"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M8.75 9.27715C8.75 8.98477 8.98703 8.74774 9.27941 8.74774H14.2206C14.513 8.74774 14.75 8.98477 14.75 9.27715V14.2183C14.75 14.5107 14.513 14.7477 14.2206 14.7477H9.27941C8.98703 14.7477 8.75 14.5107 8.75 14.2183V9.27715ZM9.80882 9.80657V13.6889H13.6912V9.80657H9.80882Z","fill":"#0D1728"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M1.25 9.27715C1.25 8.98477 1.48703 8.74774 1.77941 8.74774H6.72059C7.01297 8.74774 7.25 8.98477 7.25 9.27715V14.2183C7.25 14.5107 7.01297 14.7477 6.72059 14.7477H1.77941C1.48703 14.7477 1.25 14.5107 1.25 14.2183V9.27715ZM2.30882 9.80657V13.6889H6.19118V9.80657H2.30882Z","fill":"#0D1728"}})])])
          )
        }
      }
    